import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const SecondarySchool = () => {
     useEffect(() => {
        document.title = 'Secondary School -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li>Secondary School </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Secondary School  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <h3> Secondary Stage (Class IX - X) </h3>
       <p>The Secondary Stage focuses on academic rigor while preparing students for the Class X board exams. In this stage, students are expected to take ownership of their learning and refine their skills in critical thinking, problem-solving, and decision-making. In addition to the core subjects, we focus on the development of life skills, leadership qualities, and ethical values, ensuring students are well-rounded individuals ready for higher education or the professional world.</p>
       <p><b>Key Areas of Focus:</b></p>
       <ul className="list">
       <li> <b> Academic excellence: </b> Advanced learning techniques in mathematics, science, languages, and social sciences, with regular assessments to gauge progress.
       </li>
       <li> <b> Self-directed learning: </b> Encouraging independent study habits, time management, and research skills, preparing students for higher education.
       </li>
       <li> <b> Ethical and social responsibility: </b> Activities and discussions that promote values, citizenship, and the importance of contributing positively to society.
       </li>
       <li> <b> Co-curricular development: </b> A strong focus on sports, arts, music, and debates to foster holistic growth and help students discover their talents.
       </li>
       <li> <b> Sports: </b> Advanced involvement in athletics, swimming, and team-based competitions, with a focus on discipline, fitness, and leadership.
       </li>
       <li> <b> Multilingualism: </b> Preparing students for a globalized world by offering opportunities to learn additional languages, enhancing their communication skills and cultural understanding.
       </li>
       <li> <b> Leadership skills: </b> Opportunities to lead and mentor peers through club roles, social outreach programs, and leadership training sessions.</li>
       </ul>
       <p><b>Learning Outcomes:</b></p> 
       <ul className="list">
       <li> <b> Academic Excellence: </b> Strong conceptual understanding and exam preparation across all subjects.
       </li>
       <li> <b> Physical Competence: </b> High levels of physical fitness, teamwork, and leadership through competitive sports.
       </li>
       <li> <b> Leadership and Social Responsibility: </b> Enhanced leadership and social skills through extracurricular activities, clubs, and outreach programs.
       </li>
       <li> <b> Global Competence: </b> Increased awareness and understanding of global issues, with multilingual capabilities for effective communication.</li>
       </ul>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default SecondarySchool
